// src/GetProfile.js
import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  CircularProgress, 
  Button 
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Getprofile, Updateprofile } from '../../redux/authSlice'; // Import your updateProfile action
import { decryptUserId } from '../../utilis/encrypto';

const GetProfile = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // Track editing state
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone_number: '',
  });

  // Assuming your profile data is stored in the Redux state
  const { getprofile } = useSelector((state) => state.admin);

  useEffect(() => {
    const getProfile = async () => {
      try {
        await dispatch(Getprofile());
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getProfile();
  }, [dispatch]);

  useEffect(() => {
    if (getprofile) {
      setProfile({
        name: getprofile.name || '',
        email: getprofile.email || '',
        phone_number: getprofile.phone_number || '',
      });
    }
  }, [getprofile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({ ...prevProfile, [name]: value }));
  };

  const handleEditToggle = () => {
    setIsEditing((prev) => !prev);
  };

  const handleSave = async () => {
    try {
      await dispatch(Updateprofile(profile)); // Dispatch the update action
      setIsEditing(false);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{`Error: ${error}`}</Typography>;
  if (!getprofile) return <Typography>No profile found</Typography>;

  return (
    <Box>
      <Typography variant="h4">User Profile</Typography>

      {isEditing ? (
        <>
          <TextField
            label="Name"
            name="name"
            value={profile.name}
            onChange={handleInputChange}
            margin="normal"
            fullWidth
          />
          <TextField
            label="Email"
            name="email"
            value={profile.email}
            onChange={handleInputChange}
            margin="normal"
            fullWidth
          />
          <TextField
            label="Phone Number"
            name="phone_number"
            value={profile.phone_number}
            onChange={handleInputChange}
            margin="normal"
            fullWidth
          />
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSave}
            sx={{ mt: 2 }}
          >
            Save
          </Button>
        </>
      ) : (
        <>
          <Typography variant="h6">Name: {profile.name}</Typography>
          <Typography variant="h6">Email: {profile.email}</Typography>
          <Typography variant="h6">Phone: {profile.phone_number}</Typography>
        </>
      )}

      <Button 
        variant="outlined" 
        onClick={handleEditToggle} 
        sx={{ mt: 2 }}
      >
        {isEditing ? 'Cancel' : 'Edit Profile'}
      </Button>
    </Box>
  );
};

export default GetProfile;
